import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
export function Proof() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-teal-900 text-white py-16 md:py-20" data-id="element-158">
      <div className="max-w-4xl mx-auto px-6" data-id="element-159">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.7
      }} className="text-center" data-id="element-160">
          <QuoteIcon className="w-12 h-12 mx-auto mb-6 text-amber-400" data-id="element-161" />

          <p className="text-xl md:text-2xl leading-relaxed mb-6" data-id="element-162">
            En los primeros{' '}
            <span className="font-bold text-amber-400" data-id="element-163">10 días</span>, la
            mayoría de las mujeres reportan que la sensación de "pesadez" detrás
            de los ojos desaparece.
          </p>

          <p className="text-xl md:text-2xl leading-relaxed" data-id="element-164">
            Para el día <span className="font-bold text-amber-400" data-id="element-165">21</span>, la
            velocidad de recuperación de palabras vuelve a niveles normales y la
            energía de la tarde se estabiliza, eliminando la necesidad de
            siestas o rescates de azúcar.
          </p>
        </motion.div>
      </div>
    </section>;
}